import { motion } from "framer-motion";

// Auntie™ Avatar - Warm, nurturing Black woman AI character
export function AuntieAvatar({ size = "md", className = "" }) {
  const sizes = {
    sm: "w-16 h-16",
    md: "w-20 h-20",
    lg: "w-32 h-32",
    xl: "w-40 h-40",
  };

  return (
    <div className={`${sizes[size]} ${className} relative`}>
      <svg viewBox="0 0 200 200" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="auntieGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#E8A090" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#F5D5C8" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient id="auntieSkin" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8B5A3C" />
            <stop offset="100%" stopColor="#6B4230" />
          </linearGradient>
          <linearGradient id="auntieHair" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#2C1810" />
            <stop offset="100%" stopColor="#1A0F0A" />
          </linearGradient>
        </defs>
        <circle cx="100" cy="100" r="98" fill="url(#auntieGradient)" stroke="#E8A090" strokeWidth="2" />
        <ellipse cx="100" cy="70" rx="55" ry="50" fill="url(#auntieHair)" />
        <ellipse cx="60" cy="85" rx="20" ry="25" fill="url(#auntieHair)" />
        <ellipse cx="140" cy="85" rx="20" ry="25" fill="url(#auntieHair)" />
        <ellipse cx="100" cy="105" rx="42" ry="48" fill="url(#auntieSkin)" />
        <rect x="85" y="145" width="30" height="25" fill="url(#auntieSkin)" rx="5" />
        <path d="M55 75 Q100 55 145 75 Q148 85 145 90 Q100 70 55 90 Q52 85 55 75" fill="#E8A090" />
        <path d="M58 80 Q100 62 142 80" stroke="#F5D5C8" strokeWidth="3" fill="none" />
        <ellipse cx="82" cy="100" rx="8" ry="5" fill="#1A0F0A" />
        <ellipse cx="118" cy="100" rx="8" ry="5" fill="#1A0F0A" />
        <circle cx="84" cy="99" r="2" fill="#FFF" opacity="0.6" />
        <circle cx="120" cy="99" r="2" fill="#FFF" opacity="0.6" />
        <path d="M72 92 Q82 88 92 92" stroke="#1A0F0A" strokeWidth="2" fill="none" />
        <path d="M108 92 Q118 88 128 92" stroke="#1A0F0A" strokeWidth="2" fill="none" />
        <path d="M100 105 Q95 115 97 120 Q100 122 103 120 Q105 115 100 105" fill="#7A4A32" opacity="0.5" />
        <path d="M85 130 Q100 142 115 130" stroke="#5A3A28" strokeWidth="3" fill="none" strokeLinecap="round" />
        <circle cx="55" cy="110" r="6" fill="#E8A090" />
        <circle cx="145" cy="110" r="6" fill="#E8A090" />
        <circle cx="55" cy="118" r="4" fill="#F5D5C8" />
        <circle cx="145" cy="118" r="4" fill="#F5D5C8" />
        <path d="M60 165 Q100 155 140 165 L145 200 L55 200 Z" fill="#E8A090" />
        <path d="M70 168 Q100 160 130 168" stroke="#F5D5C8" strokeWidth="2" fill="none" />
      </svg>
    </div>
  );
}

// Unc™ Avatar - Calm, grounded Black man AI character
export function UncAvatar({ size = "md", className = "" }) {
  const sizes = {
    sm: "w-16 h-16",
    md: "w-20 h-20",
    lg: "w-32 h-32",
    xl: "w-40 h-40",
  };

  return (
    <div className={`${sizes[size]} ${className} relative`}>
      <svg viewBox="0 0 200 200" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="uncGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#A67C52" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#D4B896" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient id="uncSkin" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#5D4037" />
            <stop offset="100%" stopColor="#4E342E" />
          </linearGradient>
          <linearGradient id="uncHair" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1A1A1A" />
            <stop offset="100%" stopColor="#0D0D0D" />
          </linearGradient>
        </defs>
        <circle cx="100" cy="100" r="98" fill="url(#uncGradient)" stroke="#A67C52" strokeWidth="2" />
        <ellipse cx="100" cy="65" rx="45" ry="35" fill="url(#uncHair)" />
        <ellipse cx="100" cy="100" rx="40" ry="50" fill="url(#uncSkin)" />
        <path d="M65 110 Q100 160 135 110" fill="url(#uncSkin)" />
        <rect x="80" y="145" width="40" height="30" fill="url(#uncSkin)" rx="5" />
        <path d="M60 70 Q100 55 140 70 Q142 60 140 55 Q100 42 60 55 Q58 60 60 70" fill="url(#uncHair)" />
        <ellipse cx="82" cy="95" rx="8" ry="6" fill="#0D0D0D" />
        <ellipse cx="118" cy="95" rx="8" ry="6" fill="#0D0D0D" />
        <circle cx="84" cy="94" r="2" fill="#FFF" opacity="0.5" />
        <circle cx="120" cy="94" r="2" fill="#FFF" opacity="0.5" />
        <path d="M70 86 L92 87" stroke="#0D0D0D" strokeWidth="3" fill="none" strokeLinecap="round" />
        <path d="M108 87 L130 86" stroke="#0D0D0D" strokeWidth="3" fill="none" strokeLinecap="round" />
        <path d="M100 95 L98 115 Q100 120 102 115 L100 95" fill="#4A3028" opacity="0.4" />
        <path d="M70 120 Q100 145 130 120 Q132 135 125 145 Q100 155 75 145 Q68 135 70 120" fill="url(#uncHair)" opacity="0.8" />
        <path d="M88 130 Q100 136 112 130" stroke="#3E2723" strokeWidth="2.5" fill="none" strokeLinecap="round" />
        <ellipse cx="58" cy="100" rx="6" ry="10" fill="url(#uncSkin)" />
        <ellipse cx="142" cy="100" rx="6" ry="10" fill="url(#uncSkin)" />
        <path d="M50 165 Q100 150 150 165 L155 200 L45 200 Z" fill="#8B6B4A" />
        <path d="M80 165 L100 175 L120 165" stroke="#A67C52" strokeWidth="3" fill="none" />
      </svg>
    </div>
  );
}

// Ole Girl™ Avatar - White woman, makeup artist, culturally fluent
export function OleGirlAvatar({ size = "md", className = "" }) {
  const sizes = {
    sm: "w-16 h-16",
    md: "w-20 h-20",
    lg: "w-32 h-32",
    xl: "w-40 h-40",
  };

  return (
    <div className={`${sizes[size]} ${className} relative`}>
      <svg viewBox="0 0 200 200" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="olegirlGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#E89050" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#F5C8A0" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient id="olegirlSkin" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#F5D5C8" />
            <stop offset="100%" stopColor="#E8C4B8" />
          </linearGradient>
          <linearGradient id="olegirlHair" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#D4A574" />
            <stop offset="100%" stopColor="#B8956A" />
          </linearGradient>
        </defs>
        <circle cx="100" cy="100" r="98" fill="url(#olegirlGradient)" stroke="#E89050" strokeWidth="2" />
        {/* Hair - wavy/styled */}
        <ellipse cx="100" cy="65" rx="52" ry="45" fill="url(#olegirlHair)" />
        <ellipse cx="55" cy="90" rx="18" ry="30" fill="url(#olegirlHair)" />
        <ellipse cx="145" cy="90" rx="18" ry="30" fill="url(#olegirlHair)" />
        <ellipse cx="65" cy="120" rx="12" ry="20" fill="url(#olegirlHair)" />
        <ellipse cx="135" cy="120" rx="12" ry="20" fill="url(#olegirlHair)" />
        {/* Face */}
        <ellipse cx="100" cy="105" rx="40" ry="48" fill="url(#olegirlSkin)" />
        <rect x="88" y="148" width="24" height="22" fill="url(#olegirlSkin)" rx="5" />
        {/* Eyes with makeup */}
        <ellipse cx="82" cy="98" rx="9" ry="6" fill="#4A3728" />
        <ellipse cx="118" cy="98" rx="9" ry="6" fill="#4A3728" />
        <circle cx="84" cy="97" r="2.5" fill="#FFF" opacity="0.7" />
        <circle cx="120" cy="97" r="2.5" fill="#FFF" opacity="0.7" />
        {/* Eyeliner wing */}
        <path d="M90 98 L94 96" stroke="#2A1A10" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M126 98 L130 96" stroke="#2A1A10" strokeWidth="1.5" strokeLinecap="round" />
        {/* Eyebrows - styled */}
        <path d="M72 90 Q82 85 92 89" stroke="#8B7355" strokeWidth="2" fill="none" />
        <path d="M108 89 Q118 85 128 90" stroke="#8B7355" strokeWidth="2" fill="none" />
        {/* Nose */}
        <path d="M100 102 Q97 112 98 117 Q100 119 102 117 Q103 112 100 102" fill="#E0B0A0" opacity="0.5" />
        {/* Lips - fuller, with color */}
        <path d="M88 130 Q100 125 112 130 Q100 138 88 130" fill="#D4707A" />
        <path d="M92 130 Q100 127 108 130" stroke="#C05060" strokeWidth="1" fill="none" />
        {/* Blush */}
        <circle cx="72" cy="115" r="8" fill="#E8A0A0" opacity="0.3" />
        <circle cx="128" cy="115" r="8" fill="#E8A0A0" opacity="0.3" />
        {/* Earrings - hoops */}
        <circle cx="58" cy="108" r="8" stroke="#D4A574" strokeWidth="2" fill="none" />
        <circle cx="142" cy="108" r="8" stroke="#D4A574" strokeWidth="2" fill="none" />
        {/* Clothing */}
        <path d="M62 165 Q100 152 138 165 L142 200 L58 200 Z" fill="#E89050" />
        <path d="M75 167 Q100 158 125 167" stroke="#F5C8A0" strokeWidth="2" fill="none" />
      </svg>
    </div>
  );
}

// YK (Young King)™ Avatar - 35yo Black man, former street life, now family man
export function YKAvatar({ size = "md", className = "" }) {
  const sizes = {
    sm: "w-16 h-16",
    md: "w-20 h-20",
    lg: "w-32 h-32",
    xl: "w-40 h-40",
  };

  return (
    <div className={`${sizes[size]} ${className} relative`}>
      <svg viewBox="0 0 200 200" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="ykGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8B5A3C" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#C9A080" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient id="ykSkin" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6B4423" />
            <stop offset="100%" stopColor="#5A3A1E" />
          </linearGradient>
          <linearGradient id="ykHair" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1A1A1A" />
            <stop offset="100%" stopColor="#0A0A0A" />
          </linearGradient>
        </defs>
        <circle cx="100" cy="100" r="98" fill="url(#ykGradient)" stroke="#8B5A3C" strokeWidth="2" />
        {/* Hair - fade cut */}
        <ellipse cx="100" cy="62" rx="42" ry="32" fill="url(#ykHair)" />
        <path d="M62 60 Q100 50 138 60 Q140 70 138 75 Q100 60 62 75 Q60 70 62 60" fill="url(#ykHair)" />
        {/* Face - strong jaw */}
        <ellipse cx="100" cy="102" rx="42" ry="52" fill="url(#ykSkin)" />
        <path d="M62 115 Q100 165 138 115" fill="url(#ykSkin)" />
        {/* Neck */}
        <rect x="78" y="148" width="44" height="28" fill="url(#ykSkin)" rx="5" />
        {/* Eyes - focused, determined */}
        <ellipse cx="80" cy="95" rx="9" ry="6" fill="#0A0A0A" />
        <ellipse cx="120" cy="95" rx="9" ry="6" fill="#0A0A0A" />
        <circle cx="82" cy="94" r="2" fill="#FFF" opacity="0.5" />
        <circle cx="122" cy="94" r="2" fill="#FFF" opacity="0.5" />
        {/* Eyebrows - straight, strong */}
        <path d="M68 86 L92 86" stroke="#0A0A0A" strokeWidth="3.5" fill="none" strokeLinecap="round" />
        <path d="M108 86 L132 86" stroke="#0A0A0A" strokeWidth="3.5" fill="none" strokeLinecap="round" />
        {/* Nose */}
        <path d="M100 95 L97 112 Q100 118 103 112 L100 95" fill="#5A3018" opacity="0.4" />
        {/* Goatee/beard - neat */}
        <path d="M85 125 Q100 135 115 125 Q118 140 110 150 Q100 155 90 150 Q82 140 85 125" fill="url(#ykHair)" opacity="0.9" />
        <path d="M95 118 L95 125 M100 118 L100 128 M105 118 L105 125" stroke="url(#ykHair)" strokeWidth="2" />
        {/* Slight smile - confident */}
        <path d="M90 128 Q100 133 110 128" stroke="#4A2A15" strokeWidth="2" fill="none" strokeLinecap="round" />
        {/* Ears */}
        <ellipse cx="56" cy="100" rx="7" ry="12" fill="url(#ykSkin)" />
        <ellipse cx="144" cy="100" rx="7" ry="12" fill="url(#ykSkin)" />
        {/* Small stud earring */}
        <circle cx="56" cy="100" r="3" fill="#C0C0C0" />
        {/* Clothing - simple, clean */}
        <path d="M48 168 Q100 152 152 168 L158 200 L42 200 Z" fill="#6B4A30" />
        <path d="M85 168 L100 178 L115 168" stroke="#8B5A3C" strokeWidth="3" fill="none" />
      </svg>
    </div>
  );
}

// Animated wrapper for avatars
export function AnimatedAvatar({ children, isActive = false }) {
  return (
    <motion.div
      animate={isActive ? { scale: [1, 1.02, 1] } : {}}
      transition={{ duration: 2, repeat: Infinity }}
      className={isActive ? "drop-shadow-[0_0_15px_rgba(230,120,50,0.4)]" : ""}
    >
      {children}
    </motion.div>
  );
}
